import type {
  ExclusionPopulation,
  FollowupCohort,
  FunnelParams,
  Subpopulation,
} from './types';

/**
 * Defaults are tuned to the agreed source mix: 68% reached and 49.9% of
 * those reached screened, followed by 15% owing follow-up, 75% reached, and
 * 80% complete.
 *
 * Every value is a planning assumption to be replaced with Vitalic campaign data
 * and plan data before a working session. Provenance is surfaced in the drawer.
 */
export const DEFAULT_PARAMS: FunnelParams = {
  /* Reach blends to 68%; screen rate, weighted by reach, to 49.9%. */
  subpopulations: [
    {
      id: 'centerwell',
      name: 'Centerwell (PCPs, Care Navigators, etc.)',
      count: 982_415,
      reach: 0.75,
      screenRate: 0.6,
    },
    {
      id: 'myhumana-hra',
      name: 'MyHumana / HRAs',
      count: 589_449,
      reach: 0.65,
      screenRate: 0.4,
    },
    {
      id: 'unengaged',
      name: 'Unengaged',
      count: 392_966,
      reach: 0.55,
      screenRate: 0.33,
    },
  ],

  exclusionPopulations: [],

  outcomes: {
    noFollowup: 0.85,
    followupRequired: 0.15,
    phq2NegativeShare: 0.7,
    cssrsShare: 0.2,
  },

  followupCohorts: [
    { id: 'engaged', name: 'Engaged', share: 0.2, reach: 0.95, completion: 0.9 },
    { id: 'aware', name: 'Aware', share: 0.4, reach: 0.75, completion: 0.78 },
    { id: 'unengaged', name: 'Unengaged', share: 0.4, reach: 0.65, completion: 0.75 },
  ],
};

/** Field defaults for a row that arrives partially specified. */
export const DEFAULT_SUBPOPULATION: Omit<Subpopulation, 'id'> = {
  name: 'New source',
  count: 10_000,
  reach: 0.5,
  screenRate: 0.35,
};

export const DEFAULT_EXCLUSION_POPULATION: Omit<ExclusionPopulation, 'id'> = {
  name: 'New exclusion',
  count: 0,
};

export const DEFAULT_COHORT: Omit<FollowupCohort, 'id'> = {
  name: 'New cohort',
  share: 0.2,
  reach: 0.6,
  completion: 0.7,
};
